import { Builder as BuilderReact } from '@builder.io/react';
import { Builder as BuilderSDK } from '@builder.io/sdk';

import { BuilderModule } from './builder-module';
import migrations from '../migrations';

import ABTest from '../components/ABTest/ABTest.builder';
import ABVariant from '../components/ABVariant/ABVariant.builder';
import AccordionSection from '../components/sections/AccordionSection/AccordionSection.builder';
import Anchor from '../components/Anchor/Anchor.builder';
import AnimationsSection from '../components/sections/AnimationsSection/AnimationsSection.builder';
import AppsSection from '../components/sections/AppsSection/AppsSection.builder';
import Article from '../components/Article/Article.builder';
import Block from '../components/Block/Block.builder';
import BlockGrid from '../components/sections/BlockGrid/BlockGrid.builder';
import BlockGridItem from '../components/BlockGridItem/BlockGridItem.builder';
import BlockSection from '../components/sections/BlockSection/BlockSection.builder';
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs.builder';
import Card from '../components/Card/Card.builder';
import CarouselSection from '../components/sections/CarouselSection/CarouselSection.builder';
import ColumnsGridSection from '../components/sections/ColumnsGridSection/ColumnGridSections.builder';
import CompactCTASection from '../components/sections/CompactCTASection/CompactCTASection.builder';
import Conditional from '../components/Conditional/Conditional.builder';
import CTAClickTracking from '../components/CTAClickTracking/CTAClickTracking.builder';
import CTASection from '../components/sections/CTASection/CTASection.builder';
import EventAgendaSection from '../components/sections/EventAgendaSection/EventAgendaSection.builder';
import FAQSection from '../components/sections/FAQSection/FAQSection.builder';
import FeaturesSection from '../components/sections/FeaturesSection/FeaturesSection.builder';
import Heading from '../components/Heading/Heading.builder';
import HeadingLevel from '../components/HeadingLevel/HeadingLevel.builder';
import HeroSection from '../components/sections/HeroSection/HeroSection.builder';
import HubSpotForm from '../components/HubSpotForm/HubSpotForm.builder';
import HubSpotFormV2 from '../components/HubSpotFormV2/HubSpotFormV2.builder';
import HubSpotMeeting from '../components/HubSpotMeeting/HubSpotMeeting.builder';
import Img from '../components/Img/Img.builder';
import InViewTracking from '../components/InViewTracking/InViewTracking.builder';
import JobBoard from '../components/JobBoard/JobBoard.builder';
import LogoBar from '../components/sections/LogoBar/LogoBar.builder';
import Margin from '../components/Margin/Margin.builder';
import OneColumnBlock from '../components/sections/OneColumnBlock/OneColumnBlock.builder';
import PlanComparisonSection from '../components/sections/PlanComparison/PlanComparisonSection.builder';
import PopularTemplatesSection from '../components/sections/PopularTemplatesSection/PopularTemplatesSection.builder';
import ResourcesSection from '../components/sections/ResourcesSection/ResourcesSection.builder';
import ScrollingTweetsSection from '../components/sections/ScrollingTweetsSection/ScrollingTweetsSection.builder';
import SignUpCtaSection from '../components/sections/SignUpCtaSection/SignUpCtaSection.builder';
import SignUpForm from '../components/SignUpForm/SignUpForm.builder';
import Spacer from '../components/Spacer/Spacer.builder';
import SplitColorAccordionSection from '../components/sections/SplitColorAccordionSection/SplitColorAccordionSection.builder';
import SplitColorHero from '../components/sections/SplitColorHero/SplitColorHero.builder';
import TableSection from '../components/sections/TableSection/TableSection.builder';
import TabsSection from '../components/sections/TabsSection/TabsSection.builder';
import TestimonialCarousel from '../components/sections/TestimonialCarousel/TestimonialCarousel.builder';
import TestimonialMultipleColumn from '../components/sections/TestimonialMultipleColumn/TestimonialMultipleColumn.builder';
import TestimonialSolo from '../components/sections/TestimonialSolo/TestimonialSolo.builder';
import TestimonialsSection from '../components/sections/TestimonialsSection/TestimonialsSection.builder';
import TwoColumnRiverSection from '../components/sections/TwoColumnRiverSection/TwoColumnRiverSection.builder';
import Video from '../components/Video/Video.builder';
import VideoSection from '../components/sections/VideoSection/VideoSection.builder';
import Visibility from '../components/Visibility/Visibility.builder';
import WistiaVideo from '../components/WistiaVideo/WistiaVideo.builder';
import YouTubeVideo from '../components/YouTubeVideo/YouTubeVideo.builder';
import ZapCardSection from '../components/sections/ZapCardSection/ZapCardSection.builder';

/**
 * Declare components as desired "Insert" menu sections in Builder Editor sidebar menu
 */
const menuSections: {
  sectionTitle: string;
  componentModules: BuilderModule[];
}[] = [
  {
    sectionTitle: 'Sections',
    componentModules: [
      AccordionSection,
      BlockGrid,
      BlockSection,
      CarouselSection,
      ColumnsGridSection,
      CTASection,
      EventAgendaSection,
      Heading,
      HeroSection,
      JobBoard,
      LogoBar,
      OneColumnBlock,
      SignUpCtaSection,
      TableSection,
      TabsSection,
      TestimonialCarousel,
      TestimonialMultipleColumn,
      TestimonialSolo,
      TwoColumnRiverSection,
      ZapCardSection,
    ],
  },
  {
    sectionTitle: 'Blocks',
    componentModules: [
      Article,
      Block,
      BlockGridItem,
      Breadcrumbs,
      Card,
      HubSpotForm,
      HubSpotFormV2,
      HubSpotMeeting,
      Img,
      Margin,
      Spacer,
      SignUpForm,
      Video,
      WistiaVideo,
      YouTubeVideo,
    ],
  },
  {
    sectionTitle: 'Custom',
    componentModules: [
      AnimationsSection,
      AppsSection,
      CompactCTASection,
      FAQSection,
      FeaturesSection,
      PlanComparisonSection,
      PopularTemplatesSection,
      ResourcesSection,
      ScrollingTweetsSection,
      SplitColorAccordionSection,
      SplitColorHero,
      TestimonialsSection,
      VideoSection,
    ],
  },
  {
    sectionTitle: 'Utilities',
    componentModules: [
      ABTest,
      ABVariant,
      Anchor,
      Conditional,
      CTAClickTracking,
      HeadingLevel,
      InViewTracking,
      Visibility,
    ],
  },
];

menuSections.forEach(({ sectionTitle, componentModules }) => {
  // Register components
  componentModules.forEach(({ Component, config }) => {
    BuilderReact.registerComponent(Component, config);
  });

  // Add to "Insert" menu section
  BuilderSDK.register('insertMenu', {
    name: sectionTitle,
    items: componentModules
      .filter(({ config }) => !config.hideFromInsertMenu)
      .map(({ config }) => ({ name: config.name })),
  });
});

migrations.forEach((migrate) => migrate());
